import { render, staticRenderFns } from "./OrgsCards.vue?vue&type=template&id=5e4eb81c&scoped=true&"
import script from "./OrgsCards.vue?vue&type=script&lang=js&"
export * from "./OrgsCards.vue?vue&type=script&lang=js&"
import style0 from "./OrgsCards.vue?vue&type=style&index=0&id=5e4eb81c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4eb81c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VCardText,VCol,VContainer,VIcon,VImg,VItem,VItemGroup,VRow,VScrollYTransition})
